import type { ReadonlyVec2 } from "@core/types";
import { GARDEN_CENTER_POSITION, GARDEN_CENTER_RADIUS } from "@data/balance";

const distance = (a: ReadonlyVec2, b: ReadonlyVec2): number => Math.hypot(a.x - b.x, a.y - b.y);

/** Входные данные для проверки завершения уровня. */
export interface CompletionInput {
  player: ReadonlyVec2;
  seedsCollected: number;
  totalSeeds: number;
  alreadyComplete: boolean;
}

/** Возвращает true если в этот тик уровень должен завершиться. */
export const checkCompletion = (input: CompletionInput): boolean => {
  if (input.alreadyComplete) return false;
  if (input.seedsCollected < input.totalSeeds) return false;
  return distance(input.player, GARDEN_CENTER_POSITION) < GARDEN_CENTER_RADIUS;
};
